import React from 'react';
import { Form, Modal } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import EmailTypeService from 'services/EmailTypeService';
import LocationService from 'services/LocationService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class EditEmailTypeModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.id = opts.id;
            this.resolve = resolve;
            this.loginInfo = GlobalStateService.getValue('loginInfo');

            this.setState({
                isOpen: true,
                isLoading: true
            });
            this.load();
        });
    }

    close() {
        this.setState({
            isOpen: false
        });
    }

    async load() {
        const emailType = await EmailTypeService.get(this.id);
        const geos = await LocationService.listGeos();
        this.setState({
            emailType,
            geos,
            isLoading: false
        });
    }

    updateFields(values) {
        const emailType = { ...this.state.emailType };
        for (var field in values) {
            let value = values[field];
            emailType[field] = value;
        }
        this.setState({
            emailType
        });
    }

    async saveAndClose() {
        this.setState({
            isLoading: true
        });
        try {
            await EmailTypeService.save(this.state.emailType);
            this.close();
            this.resolve();
        } catch (error) {
            BootboxHelper.alert(error);
            this.setState({
                isLoading: false
            });
        }
    }

    async delete() {
        this.setState({
            isLoading: true
        });
        await EmailTypeService.delete(this.state.emailType.id);
        this.close();
        this.resolve();
    }

    addRecipient() {
        const recipients = [...this.state.emailType.recipients];
        recipients.push({
            type: 'To'
        });
        this.updateFields({ recipients });
    }

    updateRecipientFields(index, fields) {
        const recipients = [...this.state.emailType.recipients];
        const recipient = { ...recipients[index] };
        for (let fieldName in fields) {
            const value = fields[fieldName];
            recipient[fieldName] = value;
        }
        recipients[index] = recipient;
        this.updateFields({ recipients });
    }

    async confirmDeleteRecipient(index) {
        const confirm = await BootboxHelper.confirm('Delete this recipient?');
        if (confirm) {
            this.deleteRecipient(index);
        }
    }

    deleteRecipient(index) {
        const recipients = [...this.state.emailType.recipients];
        recipients.splice(index, 1);
        this.updateFields({ recipients });
    }

    render() {
        const {
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (<>

            <Modal show className="edit-email-type-modal">
                {this.renderInner()}
            </Modal>

        </>);
    }

    renderInner() {
        const {
            isLoading,
            emailType,
            geos,
            isReadOnly
        } = this.state;

        if (isLoading) {
            return (
                <Modal.Body>
                    <Loader />
                </Modal.Body>
            );
        }

        return (

            <form onSubmit={e => { e.preventDefault(); this.saveAndClose() }} className={isReadOnly ? ' read-only-form' : ''}>
                <Modal.Body>

                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <p className="form-control-plaintext">{emailType.name}</p>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <p className="form-control-plaintext">{emailType.description}</p>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Default recipients</Form.Label>
                        <p className="form-control-plaintext">{emailType.defaultRecipients || 'None'}</p>
                    </Form.Group>

                    <Form.Check
                        className="mb-3"
                        id="isEnabled"
                        type="checkbox"
                        checked={emailType.isEnabled}
                        onChange={e => this.updateFields({ isEnabled: e.target.checked })}
                        label="Enabled"
                    />

                    <Form.Group className="mb-3">
                        <Form.Label>Reply to</Form.Label>
                        <input
                            className="form-control"
                            type="text"
                            value={emailType.replyTo || ''} 
                            onChange={e => this.updateFields({ replyTo: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="">
                        <Form.Label>Additional recipients</Form.Label>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    {emailType.isGeoSpecific &&
                                        <th>Geo</th>
                                    }
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {emailType.recipients.map((setr, index) =>
                                    <tr key={index}>
                                        <td>
                                            <select
                                                className="form-control"
                                                value={setr.type || ''}
                                                onChange={e => this.updateRecipientFields(index, { type: e.target.value })}
                                            >
                                                <option value="To">To</option>
                                                <option value="CC">CC</option>
                                                <option value="BCC">BCC</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={setr.name || ''}
                                                onChange={e => this.updateRecipientFields(index, { name: e.target.value })}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={setr.email || ''}
                                                onChange={e => this.updateRecipientFields(index, { email: e.target.value })}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control"
                                                value={setr.role || ''}
                                                onChange={e => this.updateRecipientFields(index, { role: e.target.value })}
                                            >
                                                <option value="">(Select)</option>
                                                <option value="Admin">Admin</option>
                                                <option value="Vendor">Vendor</option>
                                                <option value="Manager">Manager</option>
                                                <option value="Instructor">Instructor</option>
                                                <option value="Accountant">Accountant</option>
                                            </select>
                                        </td>
                                        {emailType.isGeoSpecific &&
                                            <td>
                                                <select
                                                    className="form-control"
                                                    value={setr.geoID || ''}
                                                    onChange={e => this.updateRecipientFields(index, { geoID: e.target.value })}
                                                >
                                                    <option value="">(All)</option>
                                                    {geos.map(g =>
                                                        <option key={g.id} value={g.id}>
                                                            {g.name}
                                                        </option>
                                                    )}
                                                </select>
                                            </td>
                                        }
                                        <td>
                                            <button type="button" className="btn btn-danger" onClick={() => this.confirmDeleteRecipient(index)}>
                                                <span className="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </Form.Group>

                    <button type="button" className="btn btn-secondary" onClick={() => this.addRecipient()}>
                        Add recipient
                    </button>
                    
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                        Close
                    </button>
                    {!isReadOnly &&
                        <button type="submit" className="btn btn-primary ms-auto">
                            Save
                        </button>
                    }
                </Modal.Footer>
            </form>
        );
    }
}

export default EditEmailTypeModal;